import { useMemo, useState } from "react";
import { Typography, Box } from "@mui/material";
import { ErrorRetry } from "../../components/common/ErrorRetry";
import { getErrorMessage } from "../../utils/error";
import { useSubscriptionTransactions } from "../../hooks/useSubscribtionDashboard";
import BillingTransactionsFilters from "../../sections/subscriptionDashboard/BillingTransactionsFilters";
import BillingTransactionsTable from "../../sections/subscriptionDashboard/BillingTransactionsTable";

export default function BillingTransactions() {
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterPaymentMethod, setFilterPaymentMethod] = useState("all");

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const offset = page * limit;

  const queryParams = useMemo(() => {
    const trimmedQuery = searchQuery.trim();
    return {
      limit,
      offset,
      searchBy: trimmedQuery ? "account.firstName,account.lastName" : undefined,
      keyword: trimmedQuery || undefined,
      status: filterStatus !== "all" ? filterStatus : undefined,
      paymentMode:
        filterPaymentMethod !== "all" ? filterPaymentMethod : undefined,
    };
  }, [filterPaymentMethod, filterStatus, limit, offset, searchQuery]);

  const {
    data: transactionsData,
    isLoading: transactionsLoading,
    isError: transactionsError,
    error: transactionsErrorObj,
    refetch: transactionsRefetch,
  } = useSubscriptionTransactions(queryParams);

  const transactions =
    transactionsData?.data?.data ??
    transactionsData?.data ??
    transactionsData?.data?.transactions ??
    [];

  const totalCount =
    transactionsData?.data?.meta?.total ?? transactionsData?.meta?.total ?? 0;

  return (
    <Box>
      {/* Header */}
      <Box className="mb-6">
        <Typography variant="h5" className="font-bold text-slate-900">
          Billing & Transactions
        </Typography>
        <Typography variant="body2" className="text-slate-600 mt-1">
          View and manage all payment transactions
        </Typography>
      </Box>

      <BillingTransactionsFilters
        searchQuery={searchQuery}
        filterStatus={filterStatus}
        filterPaymentMethod={filterPaymentMethod}
        onSearchChange={(value) => {
          setSearchQuery(value);
          setPage(0);
        }}
        onStatusChange={(value) => {
          setFilterStatus(value);
          setPage(0);
        }}
        onPaymentMethodChange={(value) => {
          setFilterPaymentMethod(value);
          setPage(0);
        }}
      />

      {transactionsError ? (
        <ErrorRetry
          message={getErrorMessage(transactionsErrorObj)}
          onRetry={() => transactionsRefetch()}
        />
      ) : (
        <BillingTransactionsTable
          transactions={transactions}
          loading={transactionsLoading}
          page={page}
          limit={limit}
          totalCount={totalCount}
          onPageChange={(newPage) => setPage(newPage)}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setPage(0);
          }}
        />
      )}
    </Box>
  );
}
